import React, { FC, ReactNode } from "react";
import { Lexeme } from "@bumble/localization/components";

import { GridRow } from "components/shared/generic/grid/grid-row";
import { GridCol } from "components/shared/generic/grid/grid-col";
import { Grid } from "components/shared/generic/grid/grid";
import { Logo } from "components/shared/generic/logo/logo";

import styles from "./landing-footer.module.scss";

export const LandingFooter: FC<{
  text: ReactNode;
  textWidth?: number;
  ctaButtons: ReactNode;
}> = ({ text, textWidth, ctaButtons }) => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <h3
          className={styles.title}
          style={{ "--width": textWidth ? `${textWidth}px` : undefined }}
        >
          {text}
        </h3>
        <div className={styles.cta}>{ctaButtons}</div>
      </div>
      <div className={styles.footnote}>
        <Grid hasStrictWidth={true}>
          <GridRow alignItems={"center"}>
            <GridCol>
              <div className={styles.logo}>
                <Logo />
              </div>
            </GridCol>
            <GridCol>
              <div className={styles.copyright}>
                <Lexeme
                  path="corp@copyright_notice"
                  params={{ current_year: new Date().getFullYear() }}
                />
              </div>
            </GridCol>
          </GridRow>
        </Grid>
      </div>
    </div>
  );
};
